import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

export const initSentry = (release: string) =>
	Sentry.init({
		dsn,
		// Adds request headers and IP for users, for more info visit:
		// https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
		sendDefaultPii: true,
		release,
		integrations: [Sentry.extraErrorDataIntegration()],
	});
